import { render, staticRenderFns } from "./BowHeading.vue?vue&type=template&id=3e126cf4&"
import script from "./BowHeading.vue?vue&type=script&lang=js&"
export * from "./BowHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports